/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Forgot_Password_ButtonInputs */

const en_login_forgot_password_button = /** @type {(inputs: Login_Forgot_Password_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forgot Password?`)
};

const fr_login_forgot_password_button = /** @type {(inputs: Login_Forgot_Password_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mot de passe oublié ?`)
};

const de_login_forgot_password_button = /** @type {(inputs: Login_Forgot_Password_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort vergessen?`)
};

const it_login_forgot_password_button = /** @type {(inputs: Login_Forgot_Password_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ha dimenticato la password?`)
};

const ru_login_forgot_password_button = /** @type {(inputs: Login_Forgot_Password_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Забыли пароль?`)
};

const es_login_forgot_password_button = /** @type {(inputs: Login_Forgot_Password_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Has olvidado tu contraseña?`)
};

const zh_cn2_login_forgot_password_button = /** @type {(inputs: Login_Forgot_Password_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`忘记密码？`)
};

const ja_login_forgot_password_button = /** @type {(inputs: Login_Forgot_Password_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パスワードをお忘れですか？`)
};

const hi_login_forgot_password_button = /** @type {(inputs: Login_Forgot_Password_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पासवर्ड भूल गए?`)
};

const pt_pt2_login_forgot_password_button = /** @type {(inputs: Login_Forgot_Password_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esqueceu sua senha?`)
};

/**
* | output |
* | --- |
* | "Forgot Password?" |
*
* @param {Login_Forgot_Password_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_forgot_password_button = /** @type {((inputs?: Login_Forgot_Password_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Forgot_Password_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_forgot_password_button(inputs)
	if (locale === "de") return de_login_forgot_password_button(inputs)
	if (locale === "it") return it_login_forgot_password_button(inputs)
	if (locale === "ru") return ru_login_forgot_password_button(inputs)
	if (locale === "es") return es_login_forgot_password_button(inputs)
	if (locale === "zh-CN") return zh_cn2_login_forgot_password_button(inputs)
	if (locale === "ja") return ja_login_forgot_password_button(inputs)
	if (locale === "hi") return hi_login_forgot_password_button(inputs)
	if (locale === "pt-PT") return pt_pt2_login_forgot_password_button(inputs)
	return en_login_forgot_password_button(inputs)
});